// Balance de presencia calculado en el back (GET /work_records/balance), en segundos.
// La vista trabaja en milisegundos; aquí solo se convierte, sin reglas de cálculo.
export const EMPTY_BALANCE = Object.freeze({
  worked: 0, rest: 0, other: 0, total: 0, extraRest: 0, estimated: 0, absenceCompensated: 0, difference: 0,
});

export const toViewBalance = (balance) => {
  if (!balance) return { ...EMPTY_BALANCE };
  const ms = (key) => Number(balance[key] || 0) * 1000;
  return {
    worked: ms("workedSeconds"),
    rest: ms("breakSeconds"),
    other: ms("otherPauseSeconds"),
    // Total real de la ficha: trabajado + descanso; el resto de pausas se muestran aparte.
    total: ms("workedSeconds") + ms("breakSeconds"),
    extraRest: ms("breakExcessSeconds"),
    estimated: ms("expectedSeconds"),
    absenceCompensated: ms("absenceCompensatedSeconds"),
    difference: ms("differenceSeconds"),
  };
};

// Motivos por los que la jornada estimada del día difiere de la del horario.
export const balanceDayNotes = (day, formatDuration) => {
  if (!day) return [];
  const notes = [];
  if (day.isPublicHoliday) notes.push("Festivo");
  else if (day.isVacation) notes.push("Vacaciones");
  else if (!day.isWorkday) notes.push("Día no laborable en el horario asignado");
  if (Number(day.absenceCompensatedSeconds) >= 60) {
    notes.push("Ausencia compensa " + formatDuration(day.absenceCompensatedSeconds * 1000));
  }
  return notes;
};

// Diferencia del informe ("-3h 05m", "0h 00m", "18h 06m"): verde si es positiva o cero,
// rojo si es negativa, igual que en la ficha.
export const reportDifferenceClass = (value) => {
  if (typeof value !== "string" || value === "") return null;
  return value.startsWith("-") ? "difference-negative" : "difference-positive";
};
